/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import {Component, h} from 'preact';
import {PropTypes} from 'preact-compat';
import styles from './styles/AccessDeniedScreen.css';

export class AccessDeniedScreen extends Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.centerColumn}>
          <div className={styles.accessDenied} title={this.props.message || 'Access Denied'}/>
        </div>
      </div>
    );
  }
}

AccessDeniedScreen.propTypes = {message: PropTypes.string};

export default AccessDeniedScreen;